export const SUBSCRIPTION_STATUS = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
  FAILED: "FAILED",
  NEVER_SUBSCRIBED: "NEVER_SUBSCRIBED",
  PAUSED: "PAUSED",
};
